import React from 'react';
import { BigPhotoGallery } from './view/bigPhotoGallery';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'BigPhotoGallery', 
  itemElt: (item, cmsOption) => <BigPhotoGallery item={item} cmsOption={cmsOption} />
}